export default {
  setPaymentResult(state, data) {
    state.paymentResult = data;
  },

  setTransits: (state, data) => {
    state.transits = data;
  },
  setTransit: (state, data) => {
    state.transit = data;
  },
  setTransitCode: (state, data) => {
    state.transitCode = data;
  },

  setFieldReports: (state, data) => {
    state.fieldReports = data;
  },
  setFieldReport: (state, data) => {
    state.fieldReport = data;
  },
  setFieldReportCode: (state, data) => {
    state.fieldReportCode = data;
  },

  setMeterReadings: (state, data) => {
    state.meterReadings = data;
  },
  setMeterReadingCode: (state, data) => {
    state.meterReadingCode = data;
  },
  setMeterReadingAdminCode: (state, data) => {
    state.meterReadingAdminCode = data;
  },

  setWaterBills: (state, data) => {
    state.waterBills = data;
  },
  setWaterBill: (state, data) => {
    state.waterBill = data;
  },
  setWaterBillCode: (state, data) => {
    state.waterBillCode = data;
  },

  setChargeBills: (state, data) => {
    state.chargeBills = data;
  },
  setChargeBill: (state, data) => {
    state.chargeBill = data;
  },
  setChargeBillCode: (state, data) => {
    state.chargeBillCode = data;
  },

  setAutomations: (state, data) => {
    state.automations = data;
  },
  setAutomation: (state, data) => {
    state.automation = data;
  },
  setAutomationCode: (state, data) => {
    state.automationCode = data;
  },
  setAutomationCartable: (state, data) => {
    state.automationCartable = data;
  },

  setServiceRequests: (state, data) => {
    state.serviceRequests = data;
  },
  setServiceRequest: (state, data) => {
    state.serviceRequest = data;
  },
  setServiceRequestCode: (state, data) => {
    state.serviceRequestCode = data;
  },

  setBillboardRequests: (state, data) => {
    state.billboardRequests = data;
  },
  setBillboardRequest: (state, data) => {
    state.billboardRequest = data;
  },
  setBillboardRequestCode: (state, data) => {
    state.billboardRequestCode = data;
  },
  setBillboardRequestAdminCode: (state, data) => {
    state.billboardRequestAdminCode = data;
  },
  setBillboardReserveDate: (state, data) => {
    state.billboardReserveDate = data;
  },
  setIsBillboardReserveDate: (state, data) => {
    state.isBillboardReserveDate = data;
  },

  setTransactions: (state, data) => {
    state.transactions = data;
  },
  setLastVoucherInfo: (state, data) => {
    state.lastVoucherInfo = data;
  },
};
